(function DualCalendar($, Adzuki)
{
	"use strict";

	var dc = {};

	dc.initOnForm = function initOnForm($form)
	{
		var $dual_calendar,
		    $dtp_inputs;

		if (!($form instanceof jQuery)) {
			throw new Error('$form expecting jQuery object');
		}

		// no mobile dual-calendars
		if (Adzuki.is_mobile) {
			return;
		}

		$dual_calendar = $form.find('.dual-calendar');

		if (!$dual_calendar.length) {
			throw new Error('.dual-calendar not found on $form');
		}

		$dtp_inputs = $dual_calendar.find('[data-toggle=popover]');

		if (!$dtp_inputs.length) {
			throw new Error('no [data-toggle=popover] inputs found');
		}

		// suport data-value dates
		$.each($dtp_inputs, function dataValueSupport(i, dtp) {
			var $dtp = $(dtp);

			if (!$dtp.val() && $dtp.data('value')) {
				$dtp.val($dtp.data('value'));
			}
		});

		// instantiate dual-calendar popovers on the date inputs
		$dtp_inputs.popover({
			container: '#dual-calendar-container',
			html     : true,
			content  : $('#dual-calendar-body').html(), // in footer
		});



		// there can be multiple DualCalendar's on a page, so for each function
		// in here, we need to find the triggered elements' parent form.
		// we cant rely on $form like all other adzuki forms because of this,
		// except for general purpose selectors

		// dual-calendar init
		$dtp_inputs.on('inserted.bs.popover', function dualCalendarPopover()
		{
			var $self       = $(this),
			    $container  = $self.parents('.dual-calendar'),
			    $tip        = $self.data('bs.popover').tip(),
			    $inline_dtp = $tip.find('.inline-datetimepicker');

			// instantiate each dtp, in a loop so we can get default date value
			$.each($inline_dtp, function initDTP(i, dtp)
			{
				// get each dtp's respective input field
				var $input_field = $container.find($(dtp).data('text-field'));

				$(dtp).datetimepicker({
					inline       : true,
					useCurrent   : false,
					// minDate      : new Date(),
					calendarWeeks: true,

					// because the actual input fields aren't directly
					// connected to the dtp's, this format string basically
					// just tells it it's in date-only mode, hiding timepickers
					format: 'MM/DD/YYYY',
					// extraFormats : ['YYYY-MM-DD', 'MM/DD/YYYY'],

					// set the date to the current inputs value
					defaultDate: (function _getDefaultDate() {
						if ($input_field.val()) {
							return moment($input_field.val());
						}
					}()),
				});
			});

			$inline_dtp.on('dp.change', function setDate(e)
			{
				// find the correct input for this dtp
				var $self        = $(this),
				    field        = $self.data('text-field'),
				    $input_field = $container.find($(field)),
				    $linked_dtp  = $('#dual-calendar-container').find('.popover .inline-datetimepicker').not(this);

				// set the value of the text field
				$input_field.val(e.date.format('YYYY-MM-DD'));

				// if this is the start date, set the max date on the end date,
				// otherwise, set the min date on the start date
				if (field.indexOf('start') > 0) {
					$linked_dtp.data('DateTimePicker').minDate(e.date);
				}
				else {
					$linked_dtp.data('DateTimePicker').maxDate(e.date);
				}

				// trigger event for custom handlers
				$input_field.trigger('dp.change', {
					date_obj  : e.date,
					linked_dtp: $linked_dtp.data('DateTimePicker'),
				});
			});
		});
	};


	Adzuki.Web.DualCalendar = dc;
}(jQuery, window.Adzuki || {}));
